<template>
	<div class="message-settings">
		<div class="message-settings-options">
			<label>
				<input type="checkbox" value="1" class="uk-checkbox" v-model="use_phone">
				Send a text message to the number set on <a href="/profile" target="_blank">my profile</a>
			</label>
			<label>
				<input type="checkbox" value="1" class="uk-checkbox" v-model="use_email">
				Send me an email to the address set on <a href="/profile" target="_blank">my profile</a>
			</label>
			<label>
				<input type="checkbox" value="1" class="uk-checkbox" v-model="use_cc">
				Send messages to the following numbers/email addresses
			</label>
			<div class="uk-form-controls">
				<input type="text"  placeholder="Enter CC Items" class="uk-input" v-model="cc_data">
			</div>
				<small>Use a comma to separate all phone numbers and email addresses</small>
		</div>
		<div>
			<button v-if="okToTest" type="button" class="uk-button uk-button-tertiary" @click="sendTest">Test Settings</button>
			<button type="button" class="uk-button uk-button-primary" @click="saveSettingData">Save Settings</button>
		</div>
	</div>
</template>

<script>
export default {
	name: "MessageSettings",
	data() {
		return {
			use_phone: false,
			use_email: false,
			use_cc: false,
			cc_data: "",
			clearToTest: false
		}
	},
	mounted() {
		this.fetchSettingData();
	},
	methods: {
		fetchSettingData(){
			axios.get("/api/message-settings/get").then(
				(pack) => this.updateSettingData(pack),
				() => this.fetchError()
			);
		},
		updateSettingData(pack){
			if(pack.data.success){
				this.use_phone = pack.data.data.use_phone;
				this.use_email = pack.data.data.use_email;
				this.use_cc = pack.data.data.use_cc;
				this.cc_data = pack.data.data.cc_data;
			}
		},
		fetchError(){

		},
		saveSettingData(){
			this.clearToTest = true;
			axios.post("/api/message-settings/save", {
				use_phone: this.use_phone,
				use_email: this.use_email,
				use_cc: this.use_cc,
				cc_data: this.cc_data
			}).then(
				(pack) => this.updateSettingData(pack),
				() => this.fetchError()
			);
		},
		sendTest(){
			axios.get("/api/message-settings/test").then(
				(pack) => this.alertTest(pack),
				() => this.fetchError()
			);
		},
		alertTest(pack){
			console.log(pack)
		}
	},
	computed:{
		okToTest(){
			return this.clearToTest && (this.use_phone || this.use_email || (this.use_cc && this.cc_data.length > 0));
		}
	}
}
</script>
<style lang="less" scoped>
.message-settings{
	padding: 8px 14px;

	&-options{
		label {
			display: block;
		}
	}
}
</style>